//viewport
if (window.matchMedia("(min-width: 768px) and (max-width: 1024px)").matches) {
  var viewport = document.getElementsByName("viewport");
  viewport[0].setAttribute("content", "width=1920");
}
